module.exports = __webpack_public_path__ + "static/media/file-not-allowed.1a5537af.png";